export async function fetchUpdatePayment(paymentData: PaymentData | null) {
  const { appAuthorizationHeader } = useAppAuthorizationHeader()

  const route = useRoute()
  const locale = route.params.locale as string
  return await $fetch
    .raw('/customer/update/contract', {
      server: false,
      method: 'POST',
      credentials: 'include',
      headers: {
        ...(appAuthorizationHeader && appAuthorizationHeader),
      },
      baseURL: useRuntimeConfig().public.apiBaseURL,
      body: {
        concardisResponse: paymentData,
        language: locale,
        client: useRuntimeConfig().public.client,
      },
      async onResponse(context) {
        if (context.response.status === 401) {
          await fetchRefreshToken()
          //@ts-ignore
          context.response = await $fetch.raw(context.request, context.options)
        }
      },
    })
    .catch((error) => {
      return error.data
    })
}
